/**
 * Returns the aspect ratio of the given width and height as a percentage.
 */
export function aspectRatio(width, height) {
    return (height / width) * 100;
}
